var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 13.5855,
    cy: 13.5855,
    r: 13.5855,
    fill: "#F9F9F7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-twitter 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6009 10.6613C19.1943 10.842 18.7651 10.955 18.3133 11.0228C18.7651 10.7517 19.1265 10.3225 19.2847 9.8029C18.8555 10.0514 18.3811 10.2321 17.8615 10.3451C17.4549 9.91585 16.8676 9.64478 16.235 9.64478C15.0152 9.64478 14.0212 10.6387 14.0212 11.8586C14.0212 12.0393 14.0438 12.1974 14.089 12.3556C12.2592 12.2652 10.6102 11.3842 9.50328 10.0288C9.32256 10.3676 9.20961 10.7291 9.20961 11.1357C9.20961 11.9038 9.59364 12.5815 10.2036 12.9881C9.84212 12.9655 9.50328 12.8751 9.18702 12.717V12.7396C9.18702 13.8239 9.95507 14.7275 10.9716 14.9308C10.7909 14.976 10.5876 14.9986 10.3843 14.9986C10.2487 14.9986 10.0906 14.976 9.95507 14.9534C10.2487 15.8344 11.062 16.4895 12.0333 16.4895C11.2653 17.0768 10.3165 17.4383 9.27738 17.4383C9.09666 17.4383 8.91594 17.4383 8.75781 17.4157C9.75177 18.0482 10.9038 18.4096 12.1689 18.4096C16.2576 18.4096 18.494 15.0212 18.494 12.0845C18.494 11.9941 18.494 11.8812 18.494 11.7908C18.9232 11.4971 19.3073 11.1131 19.6009 10.6613Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b8ca495b3be803d7bad02a1c88507ff8.svg";
export { ForwardRef as ReactComponent };